import {
  ALL_SERVICES,
  CONNECTED_SERVICE_VALUES,
  DAYS_FILTER_DEFAULT,
  DAYS_FILTER_OPTIONS,
  SERVICE_FILTER_DEFAULT,
  type ServiceFilter,
} from '@dawn/feature-config/widgets';
import { BRAND_LABELS } from '@dawn/ui';

import type { DashboardFilterConfig, WidgetFilterConfig } from './dashboard.types';
import { NAV_IDS, type NavId } from './navigation';

interface ServiceFilterOption {
  readonly value: ServiceFilter;
  readonly label: string;
}

const SERVICE_FILTER_OPTIONS: readonly ServiceFilterOption[] = [
  { value: ALL_SERVICES, label: 'All services' },
  ...CONNECTED_SERVICE_VALUES.map((id) => ({ value: id, label: BRAND_LABELS[id] })),
];

export const GLOBAL_FILTERS: DashboardFilterConfig[] = [
  {
    id: 'timeFrame',
    type: 'radio-select',
    label: 'Time Frame',
    position: 'right',
    order: 1,
    defaultValue: String(DAYS_FILTER_DEFAULT),
    icon: 'calendar',
    options: DAYS_FILTER_OPTIONS.map(({ value, label }) => ({
      value: String(value),
      label,
    })),
  },
];

/**
 * Allow-list of nav-item ids whose pages display the global time-frame filter
 * row. Opt-in: a page shows the row only if its nav id is listed here. The
 * Access Legitimacy page is intentionally absent — it owns its own filter rail
 * (sensitivity / search / user-type / file-type). Disabled pages have no route
 * to land on, so they need no entry. Typed as `Set<NavId>` for typo-safe members
 * but exposed as `ReadonlySet<string>` so the (possibly null) active id checks
 * cleanly with `.has(activeId ?? '')`.
 */
export const GLOBAL_FILTER_NAV_IDS: ReadonlySet<string> = new Set<NavId>([
  NAV_IDS.overview,
  NAV_IDS.discoveryPrompt,
  NAV_IDS.settings,
]);

export const WIDGET_FILTERS: Record<string, WidgetFilterConfig> = {
  service: {
    id: 'service',
    type: 'radio-select',
    label: 'Service',
    defaultValue: SERVICE_FILTER_DEFAULT,
    options: SERVICE_FILTER_OPTIONS.map(({ value, label }) => ({ value, label })),
  },
};
